import { render, staticRenderFns } from "./BioTestingQuiz.vue?vue&type=template&id=5650aed8"
import script from "./BioTestingQuiz.vue?vue&type=script&lang=js"
export * from "./BioTestingQuiz.vue?vue&type=script&lang=js"
import style0 from "./BioTestingQuiz.vue?vue&type=style&index=0&id=5650aed8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports